import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { payRequestIdZodSchema } from "./pay-request-id";
import { payRequestRecipientIdZodSchema } from "./pay-request-recipient-id";

const payRequestStripeCheckoutCommandZodObject = z.object({
    _id: idZodSchema,
    _createdAt: isoAndUnixZodSchema,
    _type: z.literal("PAY_REQUEST_STRIPE_CHECKOUT_COMMAND"),
    payRequestId: payRequestIdZodSchema,
    relativeSuccessPath: z.string().url(),
    relativeCancelPath: z.string().url(),
    recipientId: payRequestRecipientIdZodSchema.optional(),
    // relativeCancelPath: z.string().url(),
});
type PayRequestStripeCheckoutCommand = z.infer<
    typeof payRequestStripeCheckoutCommandZodObject
>;
const payRequestStripeCheckoutCommandZodSchema: z.ZodSchema<PayRequestStripeCheckoutCommand> =
    payRequestStripeCheckoutCommandZodObject;

type FactoryParams = Except<
    PayRequestStripeCheckoutCommand,
    "_id" | "_type" | "_createdAt"
>;
const payRequestStripeCheckoutCommandFactory = (params: FactoryParams) => {
    const command: PayRequestStripeCheckoutCommand = {
        ...params,
        _id: generateId({ prefix: "checkout_pay_request_command__" }),
        _type: "PAY_REQUEST_STRIPE_CHECKOUT_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export {
    payRequestStripeCheckoutCommandFactory,
    payRequestStripeCheckoutCommandZodSchema,
};
export type {
    FactoryParams as CheckoutPayRequestCommandFactoryParams,
    PayRequestStripeCheckoutCommand,
};
